import React from "react";

const ReservationIcon = ({
  width = "14",
  height = "16",
  active = false,
  activeColor = "#1D5AB9",
  inActiveColor = "#969998",
  color = active ? activeColor : inActiveColor,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_620_22578)">
        <path
          d="M4 0C4.41563 0 4.75 0.334375 4.75 0.75V2H9.25V0.75C9.25 0.334375 9.58438 0 10 0C10.4156 0 10.75 0.334375 10.75 0.75V2H12C13.1031 2 14 2.89687 14 4V4.5V6V14C14 15.1031 13.1031 16 12 16H2C0.896875 16 0 15.1031 0 14V6V4.5V4C0 2.89687 0.896875 2 2 2H3.25V0.75C3.25 0.334375 3.58437 0 4 0ZM12.5 6H1.5V14C1.5 14.275 1.725 14.5 2 14.5H12C12.275 14.5 12.5 14.275 12.5 14V6ZM10.2812 9.28125L6.78125 12.7812C6.4875 13.075 6.0125 13.075 5.72188 12.7812L3.72187 10.7812C3.42812 10.4875 3.42812 10.0125 3.72187 9.72188C4.01562 9.43125 4.49062 9.42813 4.78125 9.72188L6.25 11.1906L9.21875 8.22188C9.5125 7.92813 9.9875 7.92813 10.2781 8.22188C10.5687 8.51562 10.5719 8.99063 10.2781 9.28125H10.2812Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_620_22578">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ReservationIcon;
